import * as React from 'react';
import styled from 'styled-components';
import Tippy from '@tippy.js/react';
import { shadow } from '@core-ds/primitives';

const LightTippy = styled(Tippy)`
   min-width: 200px;
   color: black;
   box-shadow: ${shadow[3]};
   padding: 0;
   border-radius: 8px;
   overflow: auto;
   background-color: white;

   .tippy-content {
      display: flex;

      > div {
         flex: 1 1 auto;
      }
   }
`;

const noop = () => {};

interface WrappedProps {
   id: string;
   href: string;
   onClick: React.MouseEventHandler;
   onKeyDown: React.KeyboardEventHandler;
   children: React.ReactNode;
}

function withTippy(ClickableElement: React.ComponentType<WrappedProps>) {
   type ResultProps = {
      onMount?: React.ReactEventHandler;
      content: React.ReactElement;
      children: React.ReactNode;
      id?: string;
   } & Omit<React.ComponentProps<typeof Tippy>, 'children' | 'onMount' | 'content' | 'id'>;
   return ({ onMount, content, children, id, ...tippyOptions }: ResultProps) => {
      return (
         <LightTippy
            trigger="click"
            duration={200}
            interactive
            placement="bottom-end"
            flip={false}
            animateFill={false}
            onMount={onMount || noop}
            content={content}
            appendTo="parent"
            {...tippyOptions}
         >
            <ClickableElement
               id={id}
               href="#"
               onClick={e => e.stopPropagation()}
               onKeyDown={e => e.stopPropagation()}
            >
               {children}
            </ClickableElement>
         </LightTippy>
      );
   };
}

export default withTippy;
